// export const GAME_SOCKET_ADDRESS = 'ws://localhost:1700';
export const GAME_SOCKET_ADDRESS = 'wss://y-backend.com:1700';
